import { EditFilter } from "@/components/campaign/configuration/EditFilter";
import { getFilterGroupById } from "@/data/filters/config";
import { Configuration } from "@/types/campaign";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { SetStateAction } from "jotai";
import { useCallback, useMemo } from "react";
import z from "zod";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/define/$category/$filter",
)({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      quality: z.number().optional(),
    }),
  ),
  loaderDeps: ({ search }) => ({ quality: search.quality }),
  loader: ({ params, deps }) => {
    const filterGroup = getFilterGroupById(params.filter);

    return {
      filterGroup,
      ...(deps.quality !== undefined
        ? {
            isBreadcrumbRoot: true,
            crumb: "Rediger filter",
          }
        : {
            crumb: filterGroup?.group.title,
          }),
    };
  },
});

function RouteComponent() {
  const { useStepper } = Route.useRouteContext();
  const { filter } = Route.useParams();
  const navigate = Route.useNavigate();

  const stepper = useStepper();

  const campaign = useMemo(() => stepper.context, [stepper.context]);
  const configuration = useMemo(
    () => campaign.configurations.find((c) => c.quality === 1),
    [campaign],
  );

  const setConfiguration = useCallback(
    (action: SetStateAction<Configuration>) => {
      stepper.setContext((prev) => ({
        ...prev,
        configurations: prev.configurations.map((c) => {
          // Update the main config AND all disabled configs
          if (c.quality === 1 || !c.enabled)
            return typeof action === "function" ? action(c) : action;
          return c;
        }),
      }));
    },
    [stepper],
  );

  if (!configuration) throw null;

  return (
    <div>
      <EditFilter
        configuration={configuration}
        setConfiguration={setConfiguration}
        isNewCampaign
        onUpdated={() => {
          navigate({ to: "/campaigns/setup/define" });
        }}
        backLinkOptions={{
          to:
            filter === "contacts"
              ? "/campaigns/setup/define"
              : "/campaigns/setup/define/$category",
        }}
        filterGroupId={filter}
        hideCancelButton={false}
        hasBorder={false}
      />
    </div>
  );
}
